import { ID } from '@datorama/akita';

export interface LifeInsurance {
  id: ID;
  person_id: number;
  second_person_id: number;
  type: string;
  annuity_percentage: string;
  end_date: number;
  insured_amount: number;
  cost: string;
  start_date: string;
  saving: number;
}

export function createLifeInsurance(params: Partial<LifeInsurance>) {
  return {

  } as LifeInsurance;
}
